import { FC, Fragment, PropsWithChildren, useEffect } from 'react';
import { bundleState } from './bundle-state';
import { HashRouting } from './hash-routing';
import { setUser, type RumUser } from './set-user';

export interface Options {
    hashRouting?: boolean;
}

const SetUser: FC<{ user?: RumUser }> = ({ user }) => {
    useEffect(() => {
        if (user) {
            setUser(user);
        }
    }, [user]);

    return null;
};

export const DatadogProvider: FC<
    PropsWithChildren & {
        isEnabled: boolean;
        user?: RumUser;
        options?: Options;
    }
> = ({ children, isEnabled, user, options }) => {
    if (isEnabled || bundleState.isSdkInitializer) {
        return (
            <Fragment>
                <SetUser user={user} />
                {options?.hashRouting && <HashRouting />}
                {children}
            </Fragment>
        );
    }
    return children;
};
